export default __webpack_public_path__ + "static/media/icons8-work-boot.0d082bed.svg";